import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DownloadHitsLayer from "../components/User/DownloadHitsLayer";

const DownloadHitsPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Curiouzz QR" />
      <DownloadHitsLayer />
    </MasterLayout>
  );
};

export default DownloadHitsPage;
